import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AbsenceHeaderComponent } from './absence-header/absence-header.component';
import { SharedModule } from "../../core/shared/shared.module";
import { AbsenceDetailsComponent } from "./absence-details.component";
import { AbsencesRest } from "../absences.rest";
import { LoginRest } from "../../login/login.rest";
import { AbsenceDetailsRouting } from "./absence-details.routing";
import { DictionaryRest } from "../../dictionaries/dictionary/dictionary.rest";
import { AbsenceHistoryComponent } from './absence-history/absence-history.component';
import { EmployeesRest } from '../../company/employees/employee.rest';

@NgModule({
  imports: [
    CommonModule,
    AbsenceDetailsRouting,
    SharedModule
  ],
  declarations: [AbsenceDetailsComponent, AbsenceHeaderComponent, AbsenceHistoryComponent],
  entryComponents: [],
  providers: [AbsencesRest, LoginRest, DictionaryRest, EmployeesRest],
  exports: []
})
export class AbsenceDetailsModule { } 